<template>
  <div>
    <section-header heading="2" ja="会員登録メールが届かない"/>
    <div class="textArea">
      <p>
        自動的に迷惑メールに振り分けられている可能性がありますので、メーラーの設定をご確認ください。<br>
        迷惑メール設定をされている場合、URL付きのメールとPCからのメールを受信できるように設定を変更してください。
      </p>
      <p>また、メール送信画面を開いたまま時間を置くと、メールを送信しても返信メールが届かない場合があります。画面を再表示、または再度読み込むなどの操作を行った後、再度お試しください。</p>
      <p>
        ▼「SoftBank/Y!mobile」をご利用のお客様<br>
        迷惑メールフィルターが「強」もしくは「標準」に設定されている場合、「puri.jp」からの登録用メールが届かない場合があります。
      </p>

      <p>[迷惑メールフィルター操作手順]</p>
      <ol>
        <li>MySoftBank(MyYmobile)へログインします。</li>
        <li>
          「メールの設定」から「迷惑メールフィルター」を選択することで、設定変更が可能です。<br>
          「利用しない」を選択して、一時的に迷惑メールフィルターの設定を変更してください。<br>
          なお、フィルター設定変更後は念のため「プリクラON」の画面を再度読み込みんでから登録用メール送信の操作を行ってください。
        </li>
        <li>登録用メールを受信し、会員登録や変更手続きなどが完了した後は迷惑メールフィルターを元の「強」または「標準」にお戻しください。</li>
      </ol>
    </div>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AboutWeb01",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push('/AboutWeb')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
  }
  ol{
    margin-top: 1em;
    list-style-position: inside;
  }
}
</style>
